import { Component, OnInit } from '@angular/core';
import { MapService } from '../../../services/map.service';

@Component({
  selector: 'ebw-map-zoom-in',
  templateUrl: './zoom-in.component.html',
  styleUrls: ['./zoom-in.component.scss']
})
export class ZoomInComponent implements OnInit {

  buttonTooltip: string = "";

  constructor(private mapService: MapService) { }

  ngOnInit(): void {
  }

  zoomIn(){
    this.mapService.mapZoom += 1;
  }

}
